import * as React from 'react';
import { observer } from 'mobx-react';
import { IBreakpoints } from '../../interfaces/IBreakpoints';
import { classes } from '~utils/Classes';
import { BREAKPOINTS_WRAPPER } from '~constants/DataTestIdAttributes';

export interface IBreakpointsWrapper {
    children?: JSX.Element | JSX.Element[];
    breakpoints: IBreakpoints;
}

export const BreakpointsWrapper = observer(function BreakpointsWrapper({
    breakpoints,
    children
}: IBreakpointsWrapper) {
    const {
        numColumnsMobile,
        numColumnsDesktop,
        numColumnsLargeScreen,
        numColumnsExtraLargeScreen
    } = breakpoints;

    const breakpointsWrapperClassName = classes('breakpoints-wrapper');

    return (
        <div
            className={breakpointsWrapperClassName}
            data-test-id={BREAKPOINTS_WRAPPER}
            data-num-columns-mobile={numColumnsMobile}
            data-num-columns-desktop={numColumnsDesktop}
            data-num-columns-large={numColumnsLargeScreen}
            data-num-columns-extra-large={numColumnsExtraLargeScreen}
        >
            {children}
        </div>
    );
});
